import {useRef, useEffect} from "react";

export const customStyles = {
    control: (base, {isFocused}) => ({
        ...base,
        fontFamily: '"Open Sans", arial, helvetica, sans-serif',
        fontSize: "16px",
        fontWeight: 600,
        fontColor: "black",
        border: "1px solid #BBBBBB",
        cursor: 'text',
        borderRadius: 8,
        padding: "0 0 0 14px",
        backgroundColor: "transparent",
        outline: isFocused && "none",
        boxShadow: "unset",
        height: "56px",
        width:"250px",
        '&:hover': {
            borderColor: '#000000',
            boxShadow: "unset",
        },
        '&:active': {
            borderColor: '#000000',
            boxShadow: "unset",
        }
    }),
    container: (base, {isFocused}) => ({
        // ...base,
        margin: "12px 0 0"
    }),
    option: (styles, {isFocused}) => ({
        ...styles,
        cursor: 'pointer',
        backgroundColor: 'white !important',
        color: isFocused ? 'black' : "#AEAEAE",
        // lineHeight: 2,
        fontFamily: '"Open Sans", arial, helvetica, sans-serif',
        fontWeight: 600,
        fontSize: 16,
        padding: "16px 0"
    }),
    noOptionsMessage: (base, state) => ({
        ...base,
        color: '#000',
        fontSize: '14px',
        fontFamily: '"Open Sans", arial, helvetica, sans-serif',
    }),
    indicatorSeparator: styles => ({
        ...styles,
        width: 0
    }),
    input: styles => ({
        ...styles,
        color: '#000',
        fontFamily: '"Open Sans", arial, helvetica, sans-serif',
        fontWeight: 600,
        margin: 0,
        paddingBottom: 0,
        paddingTop: 0,
    }),
    menu: styles => ({
        ...styles,
        marginTop: 1,
        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.12);',
        borderRadius: "0 0 8px 8px",
        padding: "14px 30px",
        top: "48px !important",
        border: "1px solid #000",
        backgroundColor: 'white',
        zIndex: 5
    }),
    list: styles => ({
        ...styles,
        border: "1px solid #000"
    }),
    menuList: styles => ({
        ...styles,
        zIndex: 12,
    }),
    singleValue: styles => ({
        ...styles,
        color: 'black',
        lineHeight: 2
    }),
};

export const isTimeNotUp = (now, startTime) => {
    // now is a Unix timestamp in milliseconds (from server, in UTC)
    // startTime is a string in format "YYYY-MM-DD-HH-mm" representing Istanbul local time (UTC+3)
    
    if (!startTime || !now) {
        return null;
    }
    
    const [startYear, startMonth, startDay, startHour, startMinute] = startTime.split("-").map(Number);
    
    // Parse the Istanbul time string and convert to UTC milliseconds
    // Create a UTC date from the Istanbul time components
    // Then adjust for the 3-hour offset (Istanbul is UTC+3)
    
    // Create UTC date treating the components as if they were UTC
    const utcDate = new Date(Date.UTC(startYear, startMonth - 1, startDay, startHour, startMinute, 0, 0));
    
    // Convert from Istanbul time (UTC+3) to UTC
    // If we have 02:30 in Istanbul, it's actually 23:30 UTC (previous day)
    // So we need to subtract 3 hours
    const istanbulOffsetMs = 3 * 60 * 60 * 1000; // 3 hours in milliseconds
    const utcStartTimestamp = utcDate.getTime() - istanbulOffsetMs;
    
    // Calculate the difference between start time (in UTC) and current time (in UTC)
    const diff = utcStartTimestamp - now;

    if (diff <= 0) {
        return null;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    var returnString = "";

    if (days > 0) {
        returnString += days + " gün ";
    }
    if (hours > 0) {
        returnString += hours + " saat ";
    }
    if (minutes > 0) {
        returnString += minutes + " dakika ";
    }

    return returnString;
};

export function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    },[value]);
    return ref.current;
}

export const generateRandomString = (len) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < len; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}